export default __webpack_public_path__ + "static/media/bg37.7e0b8f2b.jpg";